import { ConsentList } from 'src/pages/MainPage/components/ConsentForm/ConsentList';

export default ConsentList;
